import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TemplateListContainer = styled.div({
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ListWrapper = styled.div<{ hasBleed?: boolean }>({
	overflow: 'auto',
	flex: '1 1 auto',
	// When `hasBleed` is true the wrapper grows 16px past its outer position on each
	// inline edge while reserving matching internal padding. This gives template cards
	// inside it room to extend their highlight 16px beyond the original list bounds
	// without being clipped by `overflow: auto`.
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- conditional bleed for highlight
	paddingInline: (props) => (props.hasBleed ? token('space.200') : token('space.0')),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- conditional bleed for highlight
	marginInline: (props) => (props.hasBleed ? token('space.negative.200') : token('space.0')),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoriesWrapper = styled.div({
	margin: `${token('space.0')} ${token('space.050')} ${token('space.0')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortByWrapper = styled.div({
	margin: `0px 0px ${token('space.100')} ${token('space.050')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InfiniteScrollWrapper = styled.div({
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '-200px',
	height: '200px' /* height and margin must result in 0 to avoid an inner scrollbar */,
	visibility: 'hidden' /* don't show the spinner */,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CountDisplayWrapper = styled.div({
	margin: `${token('space.100')} ${token('space.0')} ${token('space.150')} ${token('space.050')}`,
	paddingTop: `${token('space.025')}`,
	color: `${token('color.text')}`,
});
